export const staticText = {
    title:"Build your Career And Upgrade Your Life",
    subTitle: "Find your best service with us",
    description:"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    buttonTitle: "Learn more"
}

export const staticText2 = {
    title:"Build your Career",
    subTitle: "Find your best course with us",
    description: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    buttonTitle: "Learn more"
}